{{ content }}
<ng-container *ngIf="nonEditedContent.length > limit">
    <span *ngIf="!isContentToggled" (click)="toggleContent()">...Read More</span>
    <span *ngIf="isContentToggled" (click)="toggleContent()">...Read Less</span>
</ng-container>